import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { getUsersByUserIds } from '../../../Datahandler';
import extractNamesFromEmail from '../../../utils/extractNameFromEmail';
import TeamCard from './TeamCard';
import { StyledMembers } from './Members.styles';

const Members = ({ memberIds, handleClick }) => {
  const [members, setMembers] = useState([]);

  const click = useCallback((user) => {
    handleClick(user);
  }, [handleClick]);

  const memoizedMemberIds = useMemo(() => memberIds, [memberIds]);

  useEffect(() => {
    getUsersByUserIds(memoizedMemberIds).then((res) => {
      setMembers(res);
    });
  }, [memberIds]);

  return (
    <StyledMembers>
      {Object.values(members).map((member, i) => {
        return (
          <div key={i} onClick={(e) => click(member.userId)}>
            <TeamCard
              key={i}
              image={
                member.imgUrl
                  ? member.imgUrl
                  : 'https://upload.wikimedia.org/wikipedia/commons/9/99/Sample_User_Icon.png'
              }
              text={
                member.name
                  ? member.name.length >= 2
                    ? member.name
                    : extractNamesFromEmail(member.email)
                  : member.username.length >= 2
                  ? member.username
                  : extractNamesFromEmail(member.email)
              }
              title={member.title}
            />
          </div>
        );
      })}
    </StyledMembers>
  );
};

export default Members;